import React from 'react';
import { HeartIcon } from 'lucide-react';
import { testimonials } from '../data/content';
export function TestimonialsSection() {
  return <section className="w-full bg-ink-950 py-20" aria-labelledby="testimonios" data-id="element-205" data-mp="20qnn9oe9sfo2">
      <div className="mx-auto w-full max-w-6xl px-4 sm:px-6" data-id="element-206" data-mp="1mz933e8mm8ff">
        <h2 id="testimonios" className="flex items-center gap-3 font-display text-3xl font-900 leading-tight text-white sm:text-4xl" style={{
        fontSize: "28px"
      }} data-id="element-207" data-mp="1r1dvyar93110">
          <HeartIcon className="h-6 w-6 flex-none text-gold" aria-hidden="true" data-id="element-208" data-mp="1d3xnyutb2z75" />
          Familias de España y Latinoamérica que ya tomaron el control
        </h2>

        <ul className="mt-10 grid gap-4 md:grid-cols-2" data-id="element-209" data-mp="1427tth81hm5o">
          {testimonials.map(item => <li key={item.name} className="flex flex-col rounded-xl border border-ink-800 bg-ink-900 p-6" data-id="element-210" data-mp="183t7v5wb86hg">
              <p className="text-xs tracking-widest text-gold" aria-label="5 de 5 estrellas" data-id="element-211" data-mp="2ydcss886laeo">
                ★★★★★
              </p>
              <p className="mt-3 text-[15px] leading-relaxed text-slate-200" data-id="element-212" data-mp="2v0sth5mdry1s">“{item.quote}”</p>
              <p className="mt-auto flex items-center gap-2.5 pt-5 text-sm text-slate-400" data-id="element-213" data-mp="2q39hydh2hzdj">
                <span className="flex h-9 w-9 items-center justify-center rounded-full bg-ink-700 font-display text-xs font-700 text-gold" data-id="element-214" data-mp="34rx824859gw3">
                  {item.initials}
                </span>
                <span data-id="element-215" data-mp="2c26sdqqv66xv">
                  <span className="block font-600 text-white" data-id="element-216" data-mp="2c3rmxgd6hpvq">{item.name}</span>
                  {item.city}
                </span>
              </p>
            </li>)}
        </ul>
      </div>
    </section>;
}